import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID = gql`
  query getDocumentImporterTemplate($id: String!) {
    getDocumentImporterTemplate(id: $id) {
      _id
      title
      companyId
      createdBy
      separator
      valueEmployeeId
    }
  }
`;

export const useGetDocumentImporterTemplate = (id?: string) => {
  const { data, loading } = useQuery(GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const documentImporterTemplate = data?.getDocumentImporterTemplate || {};

  return { documentImporterTemplate, loading };
};
